<template>
  <div class="next-meeting font-size-small">
    <div class="no-booking" v-if="!nextBooking">
      No more bookings today
    </div>
    <div v-else>
      <h2 class="next-booking font-size-small">Next Booking:</h2>
      <div>
        <span class="reservation-time" v-if="hasConnectedBookings">
          ({{ formatBookingTimes(reservationStart, reservationEnd) }})
        </span>
        <strong>{{ bookingTimes }}</strong>
      </div>
      <div class="single-height next-meeting-title">{{ bookingTitle }}</div>
      <div class=" single-height text-color-secondary" v-if="bookingOwnerName">{{ bookingOwnerName }}</div>
      <default-button
          v-if="canCheckIn && canInteract"
          :loading="bookingActionInProgress"
          @click="checkIn"
          class="check-in">
        Check In
      </default-button>
    </div>
  </div>
</template>

<script>
import DefaultButton from '@/components/DefaultButton';
import * as booking from '@/mixins/booking';
import {mapGetters} from 'vuex';

export default {
  name: 'NextMeeting',
  components: {DefaultButton},
  mixins: [booking.forProperty('nextBooking')],
  data() {
    return {
      checkInLoading: false
    };
  },
  computed: {
    ...mapGetters('time', ['now']),
    ...mapGetters('bookings', ['nextBooking']),
    ...mapGetters('config', ['readOnlyMode']),
    canInteract() {
      return !this.readOnlyMode && this.isApproved;
    }
  }
};
</script>

<style scoped>
.next-meeting {
  text-align: right;
  max-width: calc(var(--grid-size) * 7);
}

.next-meeting-title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.next-booking {
  line-height: 1em;
  margin-bottom: 1.4em;
}

.single-height {
  line-height: 1.2em;
}

.no-booking {
  position: relative;
  top: calc((var(--grid-size) * 2) - 1.1em);
}

.check-in {
  margin-top: 16px;
}

.reservation-time, .booking-date {
  opacity: 0.5;
  font-weight: normal;
}
</style>
